module.exports = __webpack_public_path__ + "static/media/donate-icon.d66bbf6b.svg";